import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherGradesOverview = () => {
  const routes = all_routes;
  const [selectedClass, setSelectedClass] = useState("all");
  const [selectedPeriod, setSelectedPeriod] = useState("current-term");

  const classesData = [
    { id: "10a", name: "Grade 10A - Mathematics", students: 30 },
    { id: "11b", name: "Grade 11B - Physics", students: 28 },
    { id: "9c", name: "Grade 9C - Mathematics", students: 32 },
  ];

  const gradesData = {
    summary: {
      totalStudents: 90,
      averageGrade: 85.6,
      gradedAssignments: 156,
      pendingGrades: 12,
      classAverage: {
        "10a": 88.2,
        "11b": 84.1,
        "9c": 84.5,
      },
    },
    recentGrades: [
      {
        id: 1,
        assignment: "Chapter 5 Quiz",
        class: "Grade 10A",
        date: "2024-08-05",
        avgGrade: 87.5,
        graded: 28,
        total: 30,
        status: "completed",
      },
      {
        id: 2,
        assignment: "Physics Lab Report",
        class: "Grade 11B",
        date: "2024-08-04",
        avgGrade: 82.1,
        graded: 25,
        total: 28,
        status: "in-progress",
      },
      {
        id: 3,
        assignment: "Geometry Test",
        class: "Grade 9C",
        date: "2024-08-03",
        avgGrade: 89.3,
        graded: 32,
        total: 32,
        status: "completed",
      },
    ],
    gradeDistribution: [
      { grade: "A (90-100)", count: 32, percentage: 35.6, color: "success" },
      { grade: "B (80-89)", count: 28, percentage: 31.1, color: "info" },
      { grade: "C (70-79)", count: 20, percentage: 22.2, color: "warning" },
      { grade: "D (60-69)", count: 7, percentage: 7.8, color: "danger" },
      { grade: "F (0-59)", count: 3, percentage: 3.3, color: "dark" },
    ],
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "success";
      case "in-progress":
        return "warning";
      case "pending":
        return "danger";
      default:
        return "secondary";
    }
  };

  const getGradeColor = (grade: number) => {
    if (grade >= 90) return "success";
    if (grade >= 80) return "info";
    if (grade >= 70) return "warning";
    return "danger";
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Grades Overview</h3>
              <p className="text-muted mb-0">
                Monitor student performance and grading progress
              </p>
            </div>
            <div className="col-auto">
              <Link to={routes.gradeEntry} className="btn btn-primary">
                <i className="ti ti-plus me-1"></i>
                Enter Grades
              </Link>
            </div>
          </div>

          {/* Filters */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Class</label>
                  <select
                    className="form-select"
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                  >
                    <option value="all">All Classes</option>
                    {classesData.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Period</label>
                  <select
                    className="form-select"
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                  >
                    <option value="current-term">Current Term</option>
                    <option value="last-term">Last Term</option>
                    <option value="semester">Full Semester</option>
                    <option value="academic-year">Academic Year</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-users text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">
                    {gradesData.summary.totalStudents}
                  </h4>
                  <p className="mb-0">Total Students</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success mb-2">
                    <i className="ti ti-chart-line text-white fs-2"></i>
                  </div>
                  <h4 className="text-success">
                    {gradesData.summary.averageGrade}%
                  </h4>
                  <p className="mb-0">Average Grade</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-info-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info mb-2">
                    <i className="ti ti-clipboard-check text-white fs-2"></i>
                  </div>
                  <h4 className="text-info">
                    {gradesData.summary.gradedAssignments}
                  </h4>
                  <p className="mb-0">Graded Assignments</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-clock text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">
                    {gradesData.summary.pendingGrades}
                  </h4>
                  <p className="mb-0">Pending Grades</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Grade Distribution */}
            <div className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-0">Grade Distribution</h5>
                </div>
                <div className="card-body">
                  {gradesData.gradeDistribution.map((item, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                      <div className="me-3" style={{ minWidth: "100px" }}>
                        <span className="fw-medium">{item.grade}</span>
                      </div>
                      <div className="flex-fill">
                        <div className="progress" style={{ height: "8px" }}>
                          <div
                            className={`progress-bar bg-${item.color}`}
                            style={{ width: `${item.percentage}%` }}
                          ></div>
                        </div>
                      </div>
                      <div
                        className="ms-3 text-end"
                        style={{ minWidth: "80px" }}
                      >
                        <span className="small text-muted">
                          {item.count} students
                        </span>
                        <div className="fw-bold">{item.percentage}%</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Class Averages */}
            <div className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-0">Class Averages</h5>
                </div>
                <div className="card-body">
                  {classesData.map((cls) => (
                    <div
                      key={cls.id}
                      className="d-flex align-items-center justify-content-between mb-3 p-3 border rounded"
                    >
                      <div>
                        <h6 className="mb-1">{cls.name}</h6>
                        <small className="text-muted">
                          {cls.students} students
                        </small>
                      </div>
                      <div className="text-end">
                        <span
                          className={`badge bg-${getGradeColor(
                            gradesData.summary.classAverage[
                              cls.id as keyof typeof gradesData.summary.classAverage
                            ]
                          )} fs-6`}
                        >
                          {
                            gradesData.summary.classAverage[
                              cls.id as keyof typeof gradesData.summary.classAverage
                            ]
                          }
                          %
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Recent Graded Assignments */}
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Recent Graded Assignments</h5>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Assignment</th>
                      <th>Class</th>
                      <th>Date</th>
                      <th>Average Grade</th>
                      <th>Progress</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gradesData.recentGrades.map((assignment) => (
                      <tr key={assignment.id}>
                        <td>
                          <h6 className="mb-0">{assignment.assignment}</h6>
                        </td>
                        <td>{assignment.class}</td>
                        <td>
                          {new Date(assignment.date).toLocaleDateString()}
                        </td>
                        <td>
                          <span
                            className={`badge bg-${getGradeColor(
                              assignment.avgGrade
                            )}`}
                          >
                            {assignment.avgGrade}%
                          </span>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div
                              className="progress me-2"
                              style={{ width: "80px", height: "6px" }}
                            >
                              <div
                                className="progress-bar bg-primary"
                                style={{
                                  width: `${
                                    (assignment.graded / assignment.total) * 100
                                  }%`,
                                }}
                              ></div>
                            </div>
                            <small>
                              {assignment.graded}/{assignment.total}
                            </small>
                          </div>
                        </td>
                        <td>
                          <span
                            className={`badge bg-${getStatusColor(
                              assignment.status
                            )}`}
                          >
                            {assignment.status}
                          </span>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-outline-secondary dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              Actions
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <Link
                                  to={routes.gradeEntry}
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-edit me-2"></i>
                                  Edit Grades
                                </Link>
                              </li>
                              <li>
                                <button className="dropdown-item">
                                  <i className="ti ti-eye me-2"></i>
                                  View Details
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item">
                                  <i className="ti ti-download me-2"></i>
                                  Export
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherGradesOverview;
